module.exports = __webpack_public_path__ + "img/f6-04.b3c6f7af.png";